import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import nelly404 from "../assets/nelly-404.png";
export const NotFound404 = () => {
    const navigate = useNavigate();
    const handleGoHome = () => {
        navigate("/");
    };
    return (_jsx(Box, { style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, var(--mantine-color-gray-0) 0%, var(--mantine-color-blue-2) 100%)",
            overflow: "hidden",
            height: "100vh",
            width: "80vw",
            margin: "0 auto"
        }, children: _jsxs(Stack, { align: "center", gap: "xl", style: {
                textAlign: "center",
                maxWidth: "600px",
                width: "100%"
            }, children: [_jsxs(Box, { style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "0.5rem"
                    }, children: [_jsx(Title, { order: 1, style: {
                                fontSize: "4rem",
                                fontWeight: 900,
                                color: "var(--mantine-color-primary-9)",
                                margin: 0,
                                textShadow: "2px 2px 4px color-mix(in srgb, var(--mantine-color-black) 10%, transparent)",
                                lineHeight: 1
                            }, children: "404" }), _jsx(Box, { style: {
                                position: "relative"
                            }, children: _jsx("img", { src: nelly404, style: {
                                    maxWidth: "500px",
                                    width: "100%",
                                    height: "auto",
                                    filter: "drop-shadow(0 10px 20px color-mix(in srgb, var(--mantine-color-black) 10%, transparent))"
                                } }) }), _jsx(Title, { order: 2, style: {
                                fontSize: "1.8rem",
                                fontWeight: 700,
                                color: "var(--mantine-color-dark-7)",
                                margin: 0,
                                lineHeight: 1.2
                            }, children: "Oops!" }), _jsxs(Text, { variant: "body", style: {
                                fontSize: "1rem",
                                color: "var(--mantine-color-gray-6)",
                                lineHeight: 1.4,
                                margin: 0,
                                maxWidth: "500px"
                            }, children: ["Looks like this page is not found. ", _jsx("br", {}), " Don't worry, we'll help you find your way back!"] })] }), _jsx(Button, { onClick: handleGoHome, children: "\uD83C\uDFE0 Take Me Home" }), _jsx(Box, { style: {
                        padding: "0.75rem",
                        backgroundColor: "var(--mantine-color-primary-1)",
                        borderRadius: "12px",
                        borderLeft: `4px solid var(--mantine-color-primary-9)`,
                        maxWidth: "400px"
                    }, children: _jsxs(Text, { variant: "body", size: "sm", style: {
                            color: "var(--mantine-color-dark-7)",
                            fontStyle: "italic",
                            margin: 0,
                            fontSize: "0.9rem"
                        }, children: [_jsx("strong", { children: "Fun Fact:" }), " Nelly loves to explore new pages, but sometimes she gets a bit too curious!"] }) })] }) }));
};
